// import React, { useState, useEffect } from 'react';
// import { ref, onValue } from 'firebase/database';
// import { db } from '../firebase';
// import { useNavigate } from 'react-router-dom';
// import ProductGrid from './ProductGrid';
// import Navbar from './Navbar';
// import Footer from './Footer'; // Import Footer component

// const WatchesPage = () => {
//   const [watches, setWatches] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const productsRef = ref(db, 'Watch/admin/products');
//     const unsubscribe = onValue(productsRef, (snapshot) => {
//       const productsData = snapshot.val();
//       if (productsData) {
//         const watchesList = Object.entries(productsData)
//           .map(([id, data]) => ({ id, ...data }))
//           .filter(product => product.category === 'watches');
//         setWatches(watchesList);
//       } else {
//         setWatches([]);
//       }
//       setLoading(false);
//     });

//     return () => unsubscribe();
//   }, []);

//   if (loading) {
//     return (
//       <div style={{
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         height: '100vh',
//         background: '#f8f5f2',
//         fontFamily: "'Montserrat', sans-serif"
//       }}>
//         <div style={{
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           gap: '20px'
//         }}>
//           <div style={{
//             width: '50px',
//             height: '50px',
//             border: '3px solid rgba(0,0,0,0.1)',
//             borderTop: '3px solid #333',
//             borderRadius: '50%',
//             animation: 'spin 1s linear infinite'
//           }}></div>
//           <span style={{
//             fontSize: '1.2rem',
//             color: '#333',
//             letterSpacing: '1px'
//           }}>Crafting Timepieces...</span>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <>
//     <Navbar />
//     <div style={{
//       background: '#f8f5f2',
//       minHeight: '100vh',
//       fontFamily: "'Montserrat', sans-serif"
//     }}>
//       {/* Hero Section */}
//       <div style={{
//         background: 'linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7))',
//         backgroundSize: 'cover',
//         backgroundPosition: 'center',
//         color: 'white',
//         padding: '100px 20px 60px',
//         textAlign: 'center',
//         marginBottom: '50px'
//       }}>
//         <h1 style={{
//           fontSize: '3.5rem',
//           fontWeight: '300',
//           letterSpacing: '2px',
//           marginBottom: '20px'
//         }}>TIMELESS ELEGANCE</h1>
//         <p style={{
//           fontSize: '1.2rem',
//           maxWidth: '700px',
//           margin: '0 auto',
//           fontWeight: '300',
//           lineHeight: '1.6'
//         }}>
//           Discover our exquisite collection of precision watches, where craftsmanship meets innovation
//         </p>
//       </div>

//       {/* Main Content */}
//       <div style={{
//         maxWidth: '1400px',
//         margin: '0 auto',
//         padding: '0 20px 60px'
//       }}>
//         {/* Collection Header */}
//         <div style={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           marginBottom: '40px',
//           borderBottom: '1px solid #e0d6cc',
//           paddingBottom: '20px'
//         }}>
//           <h2 style={{
//             fontSize: '2rem',
//             fontWeight: '400',
//             color: '#333'
//           }}>
//             Our Watch Collection
//           </h2>
//           <span style={{
//             color: '#666',
//             fontSize: '0.9rem'
//           }}>
//             {watches.length} {watches.length === 1 ? 'piece' : 'pieces'} available
//           </span>
//         </div>

//         {/* Watches Grid */}
//         {watches.length === 0 ? (
//           <div style={{
//             textAlign: 'center',
//             padding: '80px 20px',
//             background: 'white',
//             borderRadius: '8px',
//             boxShadow: '0 5px 15px rgba(0,0,0,0.05)'
//           }}>
//             <div style={{ fontSize: '4rem', marginBottom: '20px' }}>⌚</div>
//             <h3 style={{
//               fontSize: '1.5rem',
//               marginBottom: '15px',
//               color: '#333'
//             }}>No Watches Available</h3>
//             <p style={{
//               color: '#666',
//               maxWidth: '500px',
//               margin: '0 auto',
//               lineHeight: '1.6'
//             }}>
//               Our collection is currently being updated. Please check back soon for our latest timepieces.
//             </p>
//           </div>
//         ) : (
//           <ProductGrid
//             products={watches}
//             loading={loading}
//             loadingCount={12}
//             showHeader={false}
//             gridConfig={{
//               columns: {
//                 mobile: 'repeat(auto-fit, minmax(280px, 1fr))',
//                 tablet: 'repeat(auto-fit, minmax(320px, 1fr))',
//                 desktop: 'repeat(auto-fit, minmax(350px, 1fr))'
//               },
//               gap: {
//                 mobile: '16px',
//                 tablet: '24px',
//                 desktop: '30px'
//               }
//             }}
//             cardStyle={{
//               background: 'white',
//               borderRadius: '8px',
//               boxShadow: '0 5px 15px rgba(0,0,0,0.05)'
//             }}
//           />
//         )}
//       </div>

//       {/* Global styles */}
//       <style>{`
//         @keyframes spin {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg); }
//         }
//       `}</style>
//     </div>
//     <Footer />
//     </>
//   );
// };

// export default WatchesPage;


import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { db } from '../firebase';
import { useNavigate } from 'react-router-dom';
import ProductGrid from './ProductGrid';
import Navbar from './Navbar';
import Footer from './Footer';
import { FaFilter, FaTimes, FaSearch } from 'react-icons/fa';
import { BsChevronDown } from 'react-icons/bs';

const WatchesPage = () => {
  const [watches, setWatches] = useState([]);
  const [filteredWatches, setFilteredWatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showFilters, setShowFilters] = useState(false);
  const navigate = useNavigate();

  // Filter states
  const [searchTerm, setSearchTerm] = useState('');
  const [priceRange, setPriceRange] = useState([0, 50000]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedGenders, setSelectedGenders] = useState([]);
  const [selectedMaterials, setSelectedMaterials] = useState([]);
  const [selectedMovementTypes, setSelectedMovementTypes] = useState([]);
  const [selectedDialColors, setSelectedDialColors] = useState([]);
  const [selectedColors, setSelectedColors] = useState([]); // NEW: Color filter
  const [sortOption, setSortOption] = useState('featured');

  // Available filter options
  const [allBrands, setAllBrands] = useState([]);
  const [allGenders, setAllGenders] = useState([]);
  const [allMaterials, setAllMaterials] = useState([]);
  const [allMovementTypes, setAllMovementTypes] = useState([]);
  const [allDialColors, setAllDialColors] = useState([]);
  const [allColors, setAllColors] = useState([]); // NEW: All available colors

  useEffect(() => {
    const productsRef = ref(db, 'Watch/admin/products');
    const unsubscribe = onValue(productsRef, (snapshot) => {
      const productsData = snapshot.val();
      if (productsData) {
        const watchesList = Object.entries(productsData)
          .map(([id, data]) => ({ id, ...data }))
          .filter(product => product.category === 'watches');
        
        setWatches(watchesList);

        // Extract unique filter options
        const uniqueBrands = [...new Set(watchesList.map(w => w.brand).filter(Boolean))];
        setAllBrands(uniqueBrands);

        const uniqueGenders = [...new Set(
          watchesList
            .map(w => {
              const gender = w.specifications?.gender;
              return gender && typeof gender === 'string' ? gender : null;
            })
            .filter(Boolean)
        )];
        setAllGenders(uniqueGenders);

        const uniqueMaterials = [...new Set(
          watchesList.flatMap(w => {
            const materials = [];
            if (Array.isArray(w.specifications?.materials)) {
              materials.push(...w.specifications.materials.filter(m => m && typeof m === 'string'));
            } else if (w.specifications?.material && typeof w.specifications.material === 'string') {
              materials.push(w.specifications.material);
            }
            return materials;
          })
        )];
        setAllMaterials(uniqueMaterials);

        const uniqueMovementTypes = [...new Set(
          watchesList
            .map(w => {
              const movement = w.specifications?.movementType || w.specifications?.movement;
              return movement && typeof movement === 'string' ? movement : null;
            })
            .filter(Boolean)
        )];
        setAllMovementTypes(uniqueMovementTypes);

        const uniqueDialColors = [...new Set(
          watchesList
            .map(w => {
              const dialColor = w.specifications?.dialColor || w.specifications?.color;
              return dialColor && typeof dialColor === 'string' ? dialColor : null;
            })
            .filter(Boolean)
        )];
        setAllDialColors(uniqueDialColors);

        // NEW: Extract unique colors (band/strap colors)
        const uniqueColors = [...new Set(
          watchesList.flatMap(w => {
            const colors = [];
            if (Array.isArray(w.specifications?.colors)) {
              colors.push(...w.specifications.colors.filter(c => c && typeof c === 'string'));
            } else if (w.specifications?.bandColor && typeof w.specifications.bandColor === 'string') {
              colors.push(w.specifications.bandColor);
            } else if (w.specifications?.strapColor && typeof w.specifications.strapColor === 'string') {
              colors.push(w.specifications.strapColor);
            }
            return colors.map(c => c.toLowerCase());
          }).filter(Boolean)
        )];
        setAllColors(uniqueColors);
      } else {
        setWatches([]);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // Apply filters
  useEffect(() => {
    let result = [...watches];

    // Search filter
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      result = result.filter(w =>
        w.name.toLowerCase().includes(term) ||
        (w.brand && w.brand.toLowerCase().includes(term)) ||
        (w.description && w.description.toLowerCase().includes(term))
      );
    }

    // Price filter
    result = result.filter(w => w.price >= priceRange[0] && w.price <= priceRange[1]);

    // Brand filter
    if (selectedBrands.length > 0) {
      result = result.filter(w => w.brand && selectedBrands.includes(w.brand));
    }

    // Gender filter
    if (selectedGenders.length > 0) {
      result = result.filter(w => {
        const gender = w.specifications?.gender;
        return gender && typeof gender === 'string' && selectedGenders.includes(gender);
      });
    }

    // Material filter
    if (selectedMaterials.length > 0) {
      result = result.filter(w => {
        const productMaterials = [];
        if (Array.isArray(w.specifications?.materials)) {
          productMaterials.push(...w.specifications.materials.filter(m => m && typeof m === 'string'));
        } else if (w.specifications?.material && typeof w.specifications.material === 'string') {
          productMaterials.push(w.specifications.material);
        }
        return productMaterials.some(material => selectedMaterials.includes(material));
      });
    }

    // Movement type filter
    if (selectedMovementTypes.length > 0) {
      result = result.filter(w => {
        const movement = w.specifications?.movementType || w.specifications?.movement;
        return movement && typeof movement === 'string' && selectedMovementTypes.includes(movement);
      });
    }

    // Dial color filter
    if (selectedDialColors.length > 0) {
      result = result.filter(w => {
        const dialColor = w.specifications?.dialColor || w.specifications?.color;
        return dialColor && typeof dialColor === 'string' && selectedDialColors.includes(dialColor);
      });
    }

    // NEW: Color filter (band/strap color)
    if (selectedColors.length > 0) {
      result = result.filter(w => {
        const productColors = [];
        if (Array.isArray(w.specifications?.colors)) {
          productColors.push(...w.specifications.colors.filter(c => c && typeof c === 'string').map(c => c.toLowerCase()));
        } else if (w.specifications?.bandColor && typeof w.specifications.bandColor === 'string') {
          productColors.push(w.specifications.bandColor.toLowerCase());
        } else if (w.specifications?.strapColor && typeof w.specifications.strapColor === 'string') {
          productColors.push(w.specifications.strapColor.toLowerCase());
        }
        return productColors.some(color => selectedColors.includes(color));
      });
    }

    // Apply sorting
    switch (sortOption) {
      case 'price-low':
        result.sort((a, b) => a.price - b.price);
        break;
      case 'price-high':
        result.sort((a, b) => b.price - a.price);
        break;
      case 'newest':
        result.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        break;
      case 'featured':
        result.sort((a, b) => (b.featured ? 1 : 0) - (a.featured ? 1 : 0));
        break;
      case 'discount':
        result.sort((a, b) => (b.discount || 0) - (a.discount || 0));
        break;
      default:
        break;
    }

    setFilteredWatches(result);
  }, [watches, searchTerm, priceRange, selectedBrands, selectedGenders, selectedMaterials, selectedMovementTypes, selectedDialColors, selectedColors, sortOption]);

  const resetFilters = () => {
    setSearchTerm('');
    setPriceRange([0, 50000]);
    setSelectedBrands([]);
    setSelectedGenders([]);
    setSelectedMaterials([]);
    setSelectedMovementTypes([]);
    setSelectedDialColors([]);
    setSelectedColors([]); // NEW: Reset color filter
    setSortOption('featured');
  };

  const toggleFilter = (filterArray, setFilterArray, value) => {
    setFilterArray(prev =>
      prev.includes(value) ? prev.filter(item => item !== value) : [...prev, value]
    );
  };

  // NEW: Helper function to get color hex value
  const getColorValue = (colorName) => {
    const colorMap = {
      'black': '#1a1a1a',
      'white': '#ffffff',
      'red': '#e74c3c',
      'blue': '#3498db',
      'green': '#27ae60',
      'yellow': '#f1c40f',
      'silver': '#bdc3c7',
      'gold': '#f39c12',
      'rose gold': '#e8b4b8',
      'navy': '#2c3e50',
      'brown': '#8b4513',
      'gray': '#7f8c8d',
      'grey': '#7f8c8d',
      'pink': '#e91e63',
      'purple': '#9b59b6',
      'orange': '#e67e22',
      'beige': '#f5f5dc',
      'teal': '#1abc9c',
      'burgundy': '#8e2a2a',
      'tan': '#d2b48c',
      'olive': '#808000',
      'maroon': '#800000'
    };
    return colorMap[colorName?.toLowerCase()] || colorName;
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#f8f5f2',
        fontFamily: "'Montserrat', sans-serif"
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '20px'
        }}>
          <div style={{
            width: '50px',
            height: '50px',
            border: '3px solid rgba(0,0,0,0.1)',
            borderTop: '3px solid #333',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }}></div>
          <span style={{
            fontSize: '1.2rem',
            color: '#333',
            letterSpacing: '1px'
          }}>Crafting Timepieces...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <Navbar />
      <div style={{
        background: '#f8f5f2',
        minHeight: '100vh',
        fontFamily: "'Montserrat', sans-serif"
      }}>
        {/* Hero Section */}
        <div style={{
          background: 'linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7))',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          color: 'white',
          padding: '100px 20px 60px',
          textAlign: 'center',
          marginBottom: '50px'
        }}>
          <h1 style={{
            fontSize: '3.5rem',
            fontWeight: '300',
            letterSpacing: '2px',
            marginBottom: '20px'
          }}>TIMELESS ELEGANCE</h1>
          <p style={{
            fontSize: '1.2rem',
            maxWidth: '700px',
            margin: '0 auto',
            fontWeight: '300',
            lineHeight: '1.6'
          }}>
            Discover our exquisite collection of precision watches, where craftsmanship meets innovation
          </p>
        </div>

        {/* Filter Controls */}
        <div style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '0 20px 30px'
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            marginBottom: '30px'
          }}>
            {/* Search Bar */}
            <div style={{ position: 'relative', maxWidth: '600px' }}>
              <FaSearch style={{
                position: 'absolute',
                top: '50%',
                left: '15px',
                transform: 'translateY(-50%)',
                color: '#666',
                fontSize: '1rem'
              }} />
              <input
                type="text"
                placeholder="Search watches by name, brand..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  width: '100%',
                  padding: '12px 15px 12px 45px',
                  border: '1px solid #e0d6cc',
                  borderRadius: '8px',
                  background: 'white',
                  fontSize: '1rem',
                  outline: 'none',
                  transition: 'all 0.3s ease'
                }}
              />
            </div>

            {/* Controls Row */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '15px',
              flexWrap: 'wrap'
            }}>
              {/* Sort Select */}
              <div style={{ position: 'relative' }}>
                <select
                  value={sortOption}
                  onChange={(e) => setSortOption(e.target.value)}
                  style={{
                    padding: '12px 40px 12px 15px',
                    border: '1px solid #e0d6cc',
                    borderRadius: '8px',
                    background: 'white',
                    fontSize: '1rem',
                    appearance: 'none',
                    outline: 'none',
                    cursor: 'pointer',
                    minWidth: '200px'
                  }}
                >
                  <option value="featured">✨ Featured</option>
                  <option value="price-low">💰 Price: Low to High</option>
                  <option value="price-high">💎 Price: High to Low</option>
                  <option value="newest">🆕 Newest Arrivals</option>
                  <option value="discount">🔥 Best Discounts</option>
                </select>
                <BsChevronDown style={{
                  position: 'absolute',
                  right: '15px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  pointerEvents: 'none',
                  color: '#666'
                }} />
              </div>

              {/* Filter Button */}
              <button
                onClick={() => setShowFilters(true)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '12px 20px',
                  background: '#333',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
              >
                <FaFilter /> Filters
              </button>

              {/* Results Count */}
              <span style={{ color: '#666', fontSize: '0.95rem', marginLeft: 'auto' }}>
                {filteredWatches.length} {filteredWatches.length === 1 ? 'watch' : 'watches'} found
              </span>
            </div>
          </div>
        </div>

        {/* Filter Panel */}
        <div
          style={{
            position: 'fixed',
            top: 0,
            right: 0,
            bottom: 0,
            width: '400px',
            maxWidth: '90%',
            background: 'white',
            boxShadow: '-10px 0 30px rgba(0,0,0,0.1)',
            transform: showFilters ? 'translateX(0)' : 'translateX(100%)',
            transition: 'transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)',
            zIndex: 1000,
            overflowY: 'auto',
            padding: '30px',
            visibility: showFilters ? 'visible' : 'hidden',
            opacity: showFilters ? '1' : '0'
          }}
        >
          {/* Filter Header */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '30px',
            paddingBottom: '20px',
            borderBottom: '2px solid #e0d6cc'
          }}>
            <h2 style={{
              fontSize: '1.8rem',
              fontWeight: '400',
              color: '#333',
              margin: 0
            }}>Filter Watches</h2>
            <button
              onClick={() => setShowFilters(false)}
              style={{
                padding: '10px',
                border: 'none',
                background: '#f5f5f5',
                borderRadius: '50%',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <FaTimes style={{ fontSize: '1.2rem', color: '#333' }} />
            </button>
          </div>

          {/* Price Range Filter */}
          <div style={{ marginBottom: '30px' }}>
            <h3 style={{
              fontSize: '1.1rem',
              fontWeight: '500',
              color: '#333',
              marginBottom: '15px'
            }}>💰 Price Range</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <input
                  type="number"
                  value={priceRange[0]}
                  onChange={(e) => setPriceRange([parseInt(e.target.value) || 0, priceRange[1]])}
                  min="0"
                  style={{
                    flex: 1,
                    padding: '10px',
                    border: '1px solid #e0d6cc',
                    borderRadius: '6px',
                    outline: 'none'
                  }}
                />
                <span>to</span>
                <input
                  type="number"
                  value={priceRange[1]}
                  onChange={(e) => setPriceRange([priceRange[0], parseInt(e.target.value) || 50000])}
                  min={priceRange[0]}
                  style={{
                    flex: 1,
                    padding: '10px',
                    border: '1px solid #e0d6cc',
                    borderRadius: '6px',
                    outline: 'none'
                  }}
                />
              </div>
              <p style={{ textAlign: 'center', color: '#666', fontSize: '0.95rem', margin: 0 }}>
                ₹{priceRange[0].toLocaleString()} - ₹{priceRange[1].toLocaleString()}
              </p>
            </div>
          </div>

          {/* Brand Filter */}
          {allBrands.length > 0 && (
            <FilterSection
              title="🏷️ Brands"
              options={allBrands}
              selectedOptions={selectedBrands}
              onToggle={(value) => toggleFilter(selectedBrands, setSelectedBrands, value)}
            />
          )}

          {/* Gender Filter */}
          {allGenders.length > 0 && (
            <FilterSection
              title="👤 Gender"
              options={allGenders}
              selectedOptions={selectedGenders}
              onToggle={(value) => toggleFilter(selectedGenders, setSelectedGenders, value)}
            />
          )}

          {/* Movement Type Filter */}
          {allMovementTypes.length > 0 && (
            <FilterSection
              title="⚙️ Movement Type"
              options={allMovementTypes}
              selectedOptions={selectedMovementTypes}
              onToggle={(value) => toggleFilter(selectedMovementTypes, setSelectedMovementTypes, value)}
            />
          )}

          {/* Material Filter */}
          {allMaterials.length > 0 && (
            <FilterSection
              title="🧵 Case Material"
              options={allMaterials}
              selectedOptions={selectedMaterials}
              onToggle={(value) => toggleFilter(selectedMaterials, setSelectedMaterials, value)}
            />
          )}

          {/* Dial Color Filter */}
          {allDialColors.length > 0 && (
            <FilterSection
              title="🎨 Dial Color"
              options={allDialColors}
              selectedOptions={selectedDialColors}
              onToggle={(value) => toggleFilter(selectedDialColors, setSelectedDialColors, value)}
            />
          )}

          {/* NEW: Band/Strap Color Filter */}
          {allColors.length > 0 && (
            <div style={{ marginBottom: '30px' }}>
              <h3 style={{
                fontSize: '1.1rem',
                fontWeight: '500',
                color: '#333',
                marginBottom: '15px'
              }}>🎨 Band/Strap Color</h3>
              <div style={{ 
                display: 'flex', 
                flexWrap: 'wrap', 
                gap: '10px' 
              }}>
                {allColors.map(color => {
                  const colorValue = getColorValue(color);
                  const isSelected = selectedColors.includes(color);
                  return (
                    <div 
                      key={color}
                      onClick={() => toggleFilter(selectedColors, setSelectedColors, color)}
                      style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        backgroundColor: colorValue,
                        border: isSelected 
                          ? '3px solid #333' 
                          : '2px solid #e0d6cc',
                        cursor: 'pointer',
                        boxShadow: isSelected ? '0 4px 12px rgba(0,0,0,0.2)' : '0 2px 8px rgba(0,0,0,0.1)',
                        position: 'relative',
                        transition: 'all 0.3s ease',
                        transform: isSelected ? 'scale(1.1)' : 'scale(1)'
                      }}
                      title={color.charAt(0).toUpperCase() + color.slice(1)}
                    >
                      {isSelected && (
                        <div style={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          color: colorValue === '#ffffff' || colorValue === '#f1c40f' || colorValue === '#f5f5dc' ? '#333' : 'white',
                          fontSize: '16px',
                          fontWeight: 'bold'
                        }}>
                          ✓
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Reset Button */}
          <button
            onClick={() => {
              resetFilters();
              setShowFilters(false);
            }}
            style={{
              width: '100%',
              padding: '15px',
              background: '#333',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '1rem',
              fontWeight: '500',
              cursor: 'pointer',
              marginTop: '20px',
              transition: 'all 0.3s ease'
            }}
          >
            🔄 Reset All Filters
          </button>
        </div>

        {/* Backdrop */}
        {showFilters && (
          <div
            onClick={() => setShowFilters(false)}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0,0,0,0.5)',
              zIndex: 999
            }}
          />
        )}

        {/* Main Content */}
        <div style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '0 20px 60px'
        }}>
          {/* Watches Grid */}
          {filteredWatches.length === 0 ? (
            <div style={{
              textAlign: 'center',
              padding: '80px 20px',
              background: 'white',
              borderRadius: '8px',
              boxShadow: '0 5px 15px rgba(0,0,0,0.05)'
            }}>
              <div style={{ fontSize: '4rem', marginBottom: '20px' }}>⌚</div>
              <h3 style={{
                fontSize: '1.5rem',
                marginBottom: '15px',
                color: '#333'
              }}>No Watches Found</h3>
              <p style={{
                color: '#666',
                maxWidth: '500px',
                margin: '0 auto 20px',
                lineHeight: '1.6'
              }}>
                Try adjusting your filters or search term to find what you're looking for.
              </p>
              <button
                onClick={resetFilters}
                style={{
                  padding: '12px 30px',
                  background: '#333',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  fontWeight: '500',
                  cursor: 'pointer'
                }}
              >
                Reset Filters
              </button>
            </div>
          ) : (
            <ProductGrid
              products={filteredWatches}
              loading={loading}
              loadingCount={12}
              showHeader={false}
              gridConfig={{
                columns: {
                  mobile: 'repeat(2, 1fr)',
                  tablet: 'repeat(3, 1fr)',
                  desktop: 'repeat(auto-fit, minmax(350px, 1fr))'
                },
                gap: {
                  mobile: '12px',
                  tablet: '20px',
                  desktop: '30px'
                }
              }}
              cardStyle={{
                background: 'white',
                borderRadius: '8px',
                boxShadow: '0 5px 15px rgba(0,0,0,0.05)'
              }}
            />
          )}
        </div>

        {/* Global styles */}
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
      <Footer />
    </>
  );
};

// Filter Section Component
const FilterSection = ({ title, options, selectedOptions, onToggle }) => (
  <div style={{ marginBottom: '30px' }}>
    <h3 style={{
      fontSize: '1.1rem',
      fontWeight: '500',
      color: '#333',
      marginBottom: '15px'
    }}>{title}</h3>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      maxHeight: '200px',
      overflowY: 'auto'
    }}>
      {options.map(option => (
        <label
          key={option}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            padding: '10px',
            borderRadius: '6px',
            cursor: 'pointer',
            background: selectedOptions.includes(option) ? '#f5f5f5' : 'transparent',
            transition: 'all 0.3s ease'
          }}
        >
          <input
            type="checkbox"
            checked={selectedOptions.includes(option)}
            onChange={() => onToggle(option)}
            style={{
              width: '18px',
              height: '18px',
              cursor: 'pointer',
              accentColor: '#333'
            }}
          />
          <span style={{ fontSize: '0.95rem', color: '#333' }}>
            {option.charAt(0).toUpperCase() + option.slice(1)}
          </span>
        </label>
      ))}
    </div>
  </div>
);

export default WatchesPage;
